import React, { useEffect, useRef, useState } from 'react';
import { Modal, Button, Image, Ref, Form, Input, TextArea } from 'semantic-ui-react';
import SignaturePad from 'react-signature-pad-wrapper';
import { toast } from 'react-toastify';

import { useUser } from '../../hooks/user';

import AnalystColor from '../AnalystColor';

import { getBase64 } from '../../utils/getBase64';
import { pickTextColorBasedOnBgColorSimple } from '../../utils/getFontDarkOrLight';

import { styleSheet } from '../../assets/styles/global';

import {
  Header,
  InputFile,
  SignatureContainer,
  ButtonSignature,
  SignatureImage,
  DefaultLabel
} from './styles';
import { AnalystService } from '../../services/methods/AnalystService';

interface Props {
  visible: boolean;
  closeModal: () => void;
}

const EditUserProfile: React.FC<Props> = ({ visible, closeModal }) => {

  const analystService: AnalystService = new AnalystService();

  const { userInfo, setAnalystColor, setUserInfo } = useUser()

  const [updateAnalystLoading, setUpdateAnalystLoading] = useState(false);
  const [analystColorModal, setAnalystColorModal] = useState(false)
  const [analystSignatureModal, setAnalystSignatureModal] = useState(false)
  const [color, setColor] = useState("#aabbcc");
  // Campos
  const [nickName, setNickName] = useState(userInfo.apelido)
  const [address, setAddress] = useState(userInfo.endereco)
  const [professionalDescription, setProfessionalDescription] = useState(userInfo.perfil)
  const [academicFormation, setAcademicFormation] = useState(userInfo.formacao)
  const [professionalExperience, setProfessionalExperience] = useState(userInfo.experiencia)
  const [otherCourses, setOtherCourses] = useState(userInfo.cursos)

  const [haveSignature, setHaveSignature] = useState(!!userInfo.assinatura)

  const inputRef = useRef<HTMLInputElement>({} as HTMLInputElement);
  const signaturePadRef = useRef<SignaturePad>({} as SignaturePad);
  const signatureContainerRef = useRef<HTMLDivElement>({} as HTMLDivElement)
  const colorContainerRef = useRef<HTMLDivElement>({} as HTMLDivElement)
  const buttonOpenColorContainerRef = useRef<HTMLButtonElement>({} as HTMLButtonElement)
  const buttonOpenSignatureContainerRef = useRef<HTMLButtonElement>({} as HTMLButtonElement)


  const handleOpenFileInput = () => {
    inputRef.current.click();
  };

  async function handleSetFiles(files: FileList | null) {
    const token = await sessionStorage.getItem('token')
    var filesArr = Array.prototype.slice.call(files);
    const fileResponse: string = await getBase64(filesArr[0]);

    try {
      const body = {
        foto: fileResponse
      }

      const { data } = await analystService.updateAnalyst(token!, userInfo.codigo, body)

      if (data.status === 'ok') {
        const responseUserStore = await localStorage.getItem('ethosxAnalista:userInfo')
        const userStore = JSON.parse(responseUserStore!)
        userStore.foto = fileResponse
        await localStorage.setItem('ethosxAnalista:userInfo', JSON.stringify(userStore))
        setUserInfo({
          ...userInfo,
          foto: fileResponse
        })
        toast.success(data.msg)
      } else {
        toast.error(data.msg)
      }
    } catch (error: any) {
      if (error.response) {
        toast.error(error.response.data.errorMessage)
      }
      console.log(error)
    }
  }

  async function handleUpdateUserSignature(signature: string) {
    const token = await sessionStorage.getItem('token')

    try {
      const body = {
        assinatura: signature
      }

      const { data } = await analystService.updateAnalyst(token!, userInfo.codigo, body)

      if (data.status === 'ok') {
        const responseUserStore = await localStorage.getItem('ethosxAnalista:userInfo')
        const userStore = JSON.parse(responseUserStore!)
        userStore.assinatura = signature
        setAnalystSignatureModal(false)
        await localStorage.setItem('ethosxAnalista:userInfo', JSON.stringify(userStore))
        setUserInfo({
          ...userInfo,
          assinatura: signature
        })
        toast.success(data.msg)
      } else {
        toast.error(data.msg)
      }
    } catch (error: any) {
      if (error.response) {
        toast.error(error.response.data.errorMessage)
      }
      console.log(error)
    } finally {
      setHaveSignature(true)
    }
  }

  async function handleUpdateUserData() {
    try {
      setUpdateAnalystLoading(true);
      const token = await sessionStorage.getItem('token')
      const body = {
        apelido: nickName,
        endereco: address,
        perfil: professionalDescription,
        formacao: academicFormation,
        experiencia: professionalExperience,
        cursos: otherCourses,
        color
      }

      const { data } = await analystService.updateAnalyst(token!, userInfo.codigo, body)

      if (data.status === 'ok') {
        const responseUserStore = await localStorage.getItem('ethosxAnalista:userInfo')
        const userStore = JSON.parse(responseUserStore!)
        userStore.apelido = nickName
        userStore.endereco = address
        userStore.perfil = professionalDescription
        userStore.formacao = academicFormation
        userStore.experiencia = professionalExperience
        userStore.cursos = otherCourses
        await localStorage.setItem('ethosxAnalista:userInfo', JSON.stringify(userStore))
        setUserInfo({
          ...userInfo,
          apelido: nickName,
          endereco: address,
          perfil: professionalDescription,
          formacao: academicFormation,
          experiencia: professionalExperience,
          cursos: otherCourses,
          color
        })
        closeModal()
        toast.success(data.msg)
      } else {
        toast.error(data.msg)
      }
    } catch (error: any) {
      if (error.response) {
        toast.error(error.response.data.errorMessage)
      }
      console.log(error)
    } finally {
      setUpdateAnalystLoading(false);
    }
  }

  useEffect(() => {
    const checkIfClickedOutside = (e: any) => {
      if (analystSignatureModal && signatureContainerRef.current && !signatureContainerRef.current.contains(e.target) && !buttonOpenSignatureContainerRef.current.contains(e.target)) {
        setAnalystSignatureModal(false)
      }
    }

    document.addEventListener("mousedown", checkIfClickedOutside)

    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside)
    }
  }, [analystSignatureModal])

  useEffect(() => {
    const checkIfClickedOutside = (e: any) => {
      if (analystColorModal && colorContainerRef.current && !colorContainerRef.current.contains(e.target) && !buttonOpenColorContainerRef.current.contains(e.target)) {
        setAnalystColorModal(false)
      }
    }

    document.addEventListener("mousedown", checkIfClickedOutside)

    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside)
    }
  }, [analystColorModal])

  useEffect(() => {
    if (userInfo.color) {
      setColor(userInfo.color)
    }
  }, [])

  return (
    <Modal
      open={visible}
      closeIcon
      onClose={closeModal}
      size='large'
      style={{ fontFamily: styleSheet.mainFont }}
    >
      <Modal.Header>Alteração perfil de usuário</Modal.Header>
      <Modal.Content scrolling>
        <Header as='h2'>
          <Image style={{ cursor: 'pointer' }} avatar onClick={handleOpenFileInput} src={userInfo.foto === '' ? `https://ui-avatars.com/api/?background=${userInfo.color?.replace('#', '')}&color=${pickTextColorBasedOnBgColorSimple(userInfo.color).replace('#', '')}&name=${userInfo.nome}` : userInfo.foto} /> 
          {' ' + userInfo.nome}
          <InputFile type="file" accept='.png, .jpg, .jpge' ref={inputRef} onChange={(e) => handleSetFiles(e.target.files)} style={{ display: 'none' }} />
        </Header>

        <Ref innerRef={buttonOpenColorContainerRef}>
          <Button 
            size="huge"
            style={{ backgroundColor: color, color: pickTextColorBasedOnBgColorSimple(userInfo.color) }}    
            onClick={() => {
              if (color !== userInfo.color) {
                  setAnalystColor(color)
                }
                setAnalystColorModal(!analystColorModal)
                setAnalystSignatureModal(false)
            }}
          >
            {/* <Palette weight="regular" color={pickTextColorBasedOnBgColorSimple(userInfo.color)} /> */}
            {analystColorModal ? 'Alterar cor' : 'Cor do Analista'}
          </Button>
        </Ref>
        <Ref innerRef={buttonOpenSignatureContainerRef} >
          <Button
            size="huge"
            style={{ backgroundColor: styleSheet.colorMain, color: "#FFF" }}    
            onClick={() => {
              setAnalystSignatureModal(!analystSignatureModal)
              setAnalystColorModal(false)
            }}
          >
            Assinatura do Analista
          </Button>
        </Ref>
        {
          analystColorModal && (
            <div ref={colorContainerRef}>
              <AnalystColor color={color} setColor={setColor}  />
            </div>
          )
        }
        {
          analystSignatureModal && (
            <SignatureContainer ref={signatureContainerRef}>
              {
                haveSignature ? (
                  <>
                    <SignatureImage src={userInfo.assinatura} />
                    <ButtonSignature onClick={() =>
                      setHaveSignature(false)
                    } size={100} tipo="delete">Refazer Assinatura</ButtonSignature>
                  </>
                ) : (
                  <>
                    <SignaturePad
                      redrawOnResize
                      options={{ minWidth: 3, maxWidth: 3, penColor: 'rgb(0, 0, 0)' }}
                      ref={signaturePadRef}
                    />
                    <ButtonSignature size={50} onClick={() =>
                      signaturePadRef.current.clear()
                    } tipo="delete">Apagar</ButtonSignature>
                    <ButtonSignature size={50} onClick={() => {
                      handleUpdateUserSignature(signaturePadRef.current.toDataURL())
                    }} tipo="send">Enviar</ButtonSignature>
                  </>
                )
              }

            </SignatureContainer>
          )
        }

        <Form style={{ display: 'flex', flexWrap: 'wrap', gap: '1.5rem', flexGrow: '1', marginTop: '2rem' }}>
          <Form.Field  style={{ width: '49%' }}>
            <DefaultLabel>
              Apelido
            </DefaultLabel>
            <Input
              style={{ height: '4rem' }}
              placeholder={"Digite seu apelido"}
              type="text"
              onChange={
                (ev, { value }) => { setNickName(value) }
              }
              value={nickName}
            />
          </Form.Field>

          <Form.Field  style={{ width: '49%' }}>
            <DefaultLabel>
              Endereço
            </DefaultLabel>
            <Input
              style={{ height: '4rem' }}
              placeholder={"Digite seu endereço"}
              type="text"
              onChange={
                (ev, { value }) => { setAddress(value) }
              }
              value={address}
            />
          </Form.Field>

          <Form.Field style={{ width: '49%' }}>
            <DefaultLabel>
              Descrição profissional
            </DefaultLabel>
            <TextArea
              style={{ height: '150px', resize: 'none' }}
              onChange={
                (ev, { value }) => { setProfessionalDescription(String(value)) }
              }
              value={professionalDescription}
            />
          </Form.Field>

          <Form.Field style={{ width: '49%' }}>
            <DefaultLabel>
              Formação Acadêmica
            </DefaultLabel>
            <TextArea
              style={{ height: '150px', resize: 'none' }}
              onChange={
                (ev, { value }) => { setAcademicFormation(String(value)) }
              }
              value={academicFormation}
            />
          </Form.Field>

          <Form.Field style={{ width: '49%' }}>
            <DefaultLabel>
              Experiência Profissional
            </DefaultLabel>
            <TextArea
              style={{ height: '150px', resize: 'none' }}
              onChange={
                (ev, { value }) => { setProfessionalExperience(String(value)) }
              }
              value={professionalExperience}
            />
          </Form.Field>

          <Form.Field style={{ width: '49%' }}>
            <DefaultLabel>
              Outros cursos
            </DefaultLabel>
            <TextArea
              style={{ height: '150px', resize: 'none' }}
              onChange={
                (ev, { value }) => { setOtherCourses(String(value)) }
              } 
              value={otherCourses}
            />
          </Form.Field>
        </Form>

      </Modal.Content>

      <Modal.Actions>
        <Button.Group size="big">
          <Button onClick={closeModal}>Cancelar</Button>
          <Button.Or text="ou" />
          <Button 
            loading={updateAnalystLoading} 
            disabled={updateAnalystLoading}
            onClick={handleUpdateUserData} 
            positive
          >
            Atualizar
          </Button>
        </Button.Group>
      </Modal.Actions>
    </Modal>
  );
}

export default EditUserProfile;